class Diaporama {
    static init() {
        this.blocs = document.querySelectorAll(".diaporama");

        this.blocs.forEach(bloc => {
            bloc.items = bloc.querySelectorAll(".diaporama__item");

            bloc.querySelector(".diaporama__navigation__btn--prev").addEventListener("click", () => this.changePage(bloc, -1));
            bloc.querySelector(".diaporama__navigation__btn--next").addEventListener("click", () => this.changePage(bloc, 1));

            bloc.labelCurrent = bloc.querySelector(".diaporama__navigation__labelCurrent");
            bloc.labelTotal = bloc.querySelector(".diaporama__navigation__labelTotal");
            bloc.labelCredit = bloc.querySelector(".diaporama__credit");
            bloc.currentItem = 0;

            this.changePage(bloc, 0);
        });
    }


    static changePage(bloc, sens) {
        bloc.currentItem = (bloc.currentItem + sens + bloc.items.length) % bloc.items.length;
        let currentItem = bloc.items[bloc.currentItem];


        this.clearClass(bloc.items);
        bloc.items[(bloc.currentItem - 1 + bloc.items.length) % bloc.items.length].classList.add("diaporama__item--before");
        currentItem.classList.add("diaporama__item--current");
        bloc.items[(bloc.currentItem + 1 + bloc.items.length) % bloc.items.length].classList.add("diaporama__item--after");

        document.querySelector('.diaporama__lien a').href = currentItem.children[0].src;

        bloc.labelCurrent.innerHTML = (bloc.currentItem + 1);
        bloc.labelTotal.innerHTML = bloc.items.length;
        bloc.labelCredit.innerHTML = currentItem.dataset.credits;
    }

    static clearClass(items) {
        items.forEach(item => {
            item.classList.remove("diaporama__item--before");
            item.classList.remove("diaporama__item--current");
            item.classList.remove("diaporama__item--after");
        })
    }
}

export default Diaporama;


// WEBPACK FOOTER //
// ./src/scripts/components/diaporama.js